import { createShell } from '../../shell/createShell';
import { route as homeRoute } from './pages/pfhome';
import { route as offersRoute } from './pages/pfoffers';
import { route as paxRoute } from './pages/pfpax';
import { route as paymentRoute } from './pages/pfpayment';
import { route as confirmationRoute } from './pages/pfconfirmation';
import { PriceFreezeFunnel } from '.';
const routes = [homeRoute, offersRoute, paxRoute, paymentRoute, confirmationRoute];
export const priceFreezeShell = createShell(PriceFreezeFunnel, {
  options: {
    routes,
    namespace: 'price_freeze_shell_entry'
  }
});